import unityIcon from "../img/Icons/Logos/UnityLogo.png";

export default function UnitySkill(){
    return (
        <div className="skillTile">
            <img src={unityIcon} alt="unityIcon"/>
            <h2>Unity</h2>
        </div>
    )
}